import { getPublicConfig } from "../config/config"

export function useFeatureFlags() {
  const config = getPublicConfig()

  return {
    showPlaceholderContent: config.features.showPlaceholderContent,
    enableEditParent: config.features.enableEditParent,
    enablePPProvisioning: config.features.enablePPProvisioning,
    isProduction: config.environment === "production",
    isDevelopment: config.environment === "development" || config.environment === "local"
  }
}
